import { Component, OnDestroy, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { AudioRecordingService } from '@core/services/audio-recording.service';
import { DomSanitizer } from '@angular/platform-browser';
import { AnimationOptions } from 'ngx-lottie';
import { AnimationItem } from 'lottie-web';
import { CountdownComponent, CountdownConfig, CountdownEvent } from 'ngx-countdown';


@Component({
  selector: 'recoder',
  templateUrl: './recoder.component.html',
  styleUrls: ['./recoder.component.css']
})
export class RecoderComponent implements OnDestroy, OnInit {
  public config: CountdownConfig = {
    leftTime: 0,
    format: 'ss',
  };
  @ViewChild('countdown', { static: false }) private countdown: CountdownComponent;

  public isCountDown: boolean = true;
  @Input() evaluateObj: any;
  @Output() emitFile: any = new EventEmitter<any>();

  isRecording = false;
  recordedTime: any;
  blobUrl: any;

  public interval1: any;
  public anni: String;
  public isNoEvaluate: boolean = false;

  constructor(private audioRecordingService: AudioRecordingService, private sanitizer: DomSanitizer) {
    this.audioRecordingService.recordingFailed().subscribe(() => {
      this.isRecording = false;
    });

    this.audioRecordingService.getRecordedTime().subscribe((time) => {
      this.recordedTime = time;
    });
    this.audioRecordingService.getRecordedBlob().subscribe((data) => {
      this.blobUrl = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(data.blob));
      const file = new File([data.blob], this.evaluateObj.questionId);
      console.log('here reach')
      let temp = {
        file: file,
        isTimmer: this.isCountDown,
        recoderStatus: "end",
        blobUrl: this.blobUrl
      };
      this.emitFile.emit(temp);
    });
  }

  ngOnInit() {
    this.config.leftTime = this.evaluateObj.duration;
    this.isCountDown = true;
    setTimeout(() => {
      this.getCountDown();
    }, 100);
  }

  startRecording() {
    console.log('here record start')
    if (!this.isRecording) {
      this.isRecording = true;
      this.audioRecordingService.startRecording();
    }
  }

  abortRecording() {
    if (this.isRecording) {
      this.isRecording = false;
      this.audioRecordingService.abortRecording();
    }
  }

  stopRecording() {
    console.log(this.isRecording)
    if (this.isRecording) {
      this.audioRecordingService.stopRecording(this.evaluateObj.questionId);
      this.isRecording = false;
    }
  }

  clearRecordedData() {
    this.blobUrl = null;
  }

  ngOnDestroy(): void {
    this.abortRecording();
    clearInterval(this.interval1);
    clearInterval(this.interval);
  }

  public status: any;
  timmerEnd(e: boolean) {
    console.log('timmer end')
    this.countdown.stop();
    this.isCountDown = e;
    if (this.status != "started") {
      this.status = "start";


      setTimeout(() => {
        if (this.evaluateObj.questionType != "S002" && this.evaluateObj.questionType != "S005")
          this.playAudioBeep();
        else this.startRecording();

        setTimeout(() => {

          this.decrease();
        }, 100);

      });
    }
    clearInterval(this.interval1);
  }

  value = 0;
  public interval: any;
  decrease() {
    this.status = "started";
    if (this.value == 0) {
      this.value = 1;
      var elem = document.getElementById("myBar");
      var width = 1;
      this.interval = setInterval(() => {
        if (width >= 100) {
          clearInterval(this.interval);
          this.value = 0;
          this.stopRecording();
        } else {
          width++;
          elem.style.width = width + "%";
        }
      }, this.evaluateObj.recordDuration * 10)
    }
  }


  getCountDown() {
    let countdown = this.evaluateObj.duration;

    this.anni = 'countdown ' + (parseInt(countdown) + 1) + 's linear infinite forwards'
  }

  onRestart() {
    clearInterval(this.interval1);
    clearInterval(this.interval);
    this.stopRecording();
    this.isCountDown = true;
    this.status = undefined;
    this.anni = undefined;
    setTimeout(() => {
      this.getCountDown();
    }, 100);
  }

  handleEvent(e: CountdownEvent) {
    if (e.action === 'done')
      this.timmerEnd(false);
  }

  onEnd() {
    console.log('on end')
    // if (this.isNoEvaluate) {
    //   let temp = {
    //     file: null,
    //     isTimmer: this.isCountDown,
    //     recoderStatus: "end"
    //   };
    //   this.emitFile.emit(temp);
    // }
    clearInterval(this.interval1);
    clearInterval(this.interval);
    this.stopRecording();
    this.isCountDown = undefined;
    this.status = undefined;
    this.anni = undefined;
  }

  ngOnChanges(changes) {
    this.value = 0;
  }

  playAudioBeep() {
    this.startRecording();
    let audio = new Audio();
    audio.src = "assets/audio/SpeakingBeep.wav";
    audio.load();
    audio.play();


  }

  options: AnimationOptions = {
    path: 'assets/icon/lottie/audio.json',
  };

  styles: Partial<CSSStyleDeclaration> = {
    margin: '10px',
  };



}
